<fui-filter-fascia [disabled]="disabled" [focussed]="focussed" (focussed$)="focus()" [hovered]="hovered">
    <fui-fixtures>
        <fui-fixture>
            <fui-filter-label [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                              [title]="label" [valued]="valued"></fui-filter-label>
        </fui-fixture>
    </fui-fixtures>
    <fui-fixtures>
        <fui-fixture *ngIf="icon">
            <ng-content select="fui-icon"></ng-content>
        </fui-fixture>
        <fui-fixture *ngIf="!icon">
            <fui-icon [height]="12" [icon]="'lookup'" [width]="12"></fui-icon>
        </fui-fixture>
        <fui-spanning-fixture>
            <fui-input-dom>
                <input (blur)="onBlur($event)" [disabled]="disabled" #input (focus)="onFocus($event)"
                       [(ngModel)]="displayedValue"
                       [placeholder]="placeholder | translate" [tabindex]="tabindex" type="text" inputmode="decimal">
            </fui-input-dom>
        </fui-spanning-fixture>
    </fui-fixtures>
</fui-filter-fascia>
